import(/* webpackMode: "eager", webpackExports: ["TabsAbout"] */ "C:\\Users\\Administrator\\Documents\\GitHub\\pione-group-v1\\src\\components\\marketing\\tabs-about.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundBeams"] */ "C:\\Users\\Administrator\\Documents\\GitHub\\pione-group-v1\\src\\components\\ui\\background-beams.tsx");
